// Resolvers
import { saveIbanAccountResolver } from '../resolvers/financial-data.resolver';
// Types
import {
  FinancialDataHandlersBuilderType,
  FinancialDataHandlersCloseBuilderType,
  FinancialDataHandlersReturnType,
} from './types/financial-data.handlers.type';

const saveChangedIbanHandler = async ({
  ibanList,
  selectedIban,
  setError,
  setFetchingSave,
  setFlowApiData,
  setShowIbanSelector,
}: FinancialDataHandlersBuilderType): Promise<void> => {
  setFetchingSave(true);
  const [success] = await saveIbanAccountResolver(selectedIban);

  if (success) {
    setFlowApiData(prev => ({ ...prev, accounts: ibanList }));
    setShowIbanSelector(false);
  } else {
    setError(true);
  }
  setFetchingSave(false);
};

const closeIbanSelectorHandler = ({
  setShowIbanSelector,
}: FinancialDataHandlersCloseBuilderType): void => {
  setShowIbanSelector(false);
};

const FinancialDataHandlers = ({
  ibanList,
  selectedIban,
  setError,
  setFetchingSave,
  setFlowApiData,
  setShowIbanSelector,
}: FinancialDataHandlersBuilderType): FinancialDataHandlersReturnType => ({
  handleCloseIbanSelector: () => closeIbanSelectorHandler({ setShowIbanSelector }),
  handleSaveChangedIban: () =>
    saveChangedIbanHandler({
      ibanList,
      selectedIban,
      setError,
      setFetchingSave,
      setFlowApiData,
      setShowIbanSelector,
    }),
});

export { FinancialDataHandlers };
